import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2ec53e20&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2ec53e20&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec53e20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\IdeaProjects\\datangAdd\\crmeb_javashao\\crmeb_java_xxt\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ec53e20')) {
      api.createRecord('2ec53e20', component.options)
    } else {
      api.reload('2ec53e20', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2ec53e20&scoped=true", function () {
      api.rerender('2ec53e20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploadPicture/index.vue"
export default component.exports